import type { LandscapeDocumentary } from '@/types';
import { getMediaData } from '@/lib/utils/media.utils';

/** Films side by side: two to a row, or three across when there are exactly three. */
export const rowColumns = (count: number) => (count === 3 ? 'lg:grid-cols-3' : 'lg:grid-cols-2');

/**
 * The shape every frame of a row takes, when the row's first film stands upright and has a still
 * to tell its shape. Upright films of slightly different shapes then stand at one height, each
 * filling its card. A row of wide films keeps the 16:9 frames it always had.
 */
export function rowFrame(blocks: LandscapeDocumentary[]): number | undefined {
  const still = blocks[0]?.image ? getMediaData(blocks[0].image) : null;
  const shape = still?.width && still?.height ? still.width / still.height : null;
  return shape && shape < 1 ? shape : undefined;
}
